import { has, round } from 'lodash'
export const mapIdBtnToValueMatrix = {
  // i valori corrispondono agli indici dei 3 blocchi pull, push, pushestremo nella grid
  none: -1,
  pull: 0,
  push: 1,
  pest: 2
}

export const recalculateRowWithCompare = (row, btnActiveId) => {
  const matrixValues = row?.value //[ arrPull, arrPush, arrPest]

  const selectedArrayBlock = matrixValues[mapIdBtnToValueMatrix[btnActiveId]]

  const newMatrix = matrixValues?.map((currentArray, idx) => {
    if (idx === mapIdBtnToValueMatrix[btnActiveId]) {
      return currentArray.map((config) => ({ ...config, type: 'selected' }))
    }
    return calculateValueDiff(selectedArrayBlock, currentArray)
  })

  return { ...row, value: newMatrix }
}

const calculateValueDiff = (selectedArrayBlock, currentArrayBlock) => {
  const newCurrentArrayBlock = currentArrayBlock.map((currObj, idx) => {
    return calculateNewValue(currObj, selectedArrayBlock[idx])
  })
  /**
   * ((currval - selectedval) / selectedval)*100
   */
  return newCurrentArrayBlock
}

const calculateNewValue = (currentValueObj, selectedValueObj) => {
  const currValue = currentValueObj?.value
  const selectedValue = selectedValueObj?.value

  // eslint-disable-next-line eqeqeq
  if (selectedValue == 0) return { ...currentValueObj, value: '-' } //gestisce divBy0

  const newValue = (currValue - selectedValue) / selectedValue
  return {
    ...currentValueObj,
    value: round(newValue * 100, 2),
    ...(newValue !== 0 && {
      //se non 0 metti decorator
      decoration: newValue > 0 ? 'success' : 'danger'
    })
  }
}

export const addAccordionProperties = (items) => {
  return items?.map((item) => {
    if (has(item, 'father')) return { ...item, show: false }
    else if (has(item, 'accordion')) return { ...item, open: false }
    else return item
  })
}

export const formatNumber = (value) => {
  const formattedValue = new Intl.NumberFormat('it-IT', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(value)
  return formattedValue
}
